import { useEffect, useState } from 'react';
import mediaQueryMatches from '../utils/viewport';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const getImageSize = () => mediaQueryMatches('min-width: 48em') ? '800' : '200';
const ProductImageryContent = ({
  displayElements,
  iconName,
  productName
}) => {
  const [image, setImage] = useState(null);
  const {
    Icon,
    ImageContainer,
    Wrapper
  } = displayElements;
  useEffect(() => {
    if (productName) {
      (async () => {
        try {
          const img = await import(`@eti/assets/images/products/${productName}_${getImageSize()}.jpg`);
          setImage(img.default);
        } catch {
          console.error(`Warning: No image was found for the ’${productName}’ product`); // oxlint-disable-line no-console
        }
      })();
    }
  }, [productName]);
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [image && /*#__PURE__*/_jsx(ImageContainer, {
      className: "product-image",
      "data-productimage": true,
      "data-testid": `${productName}-ProductImageryContent`,
      image: image
    }), /*#__PURE__*/_jsx(Icon, {
      id: iconName || productName
    })]
  });
};
export default ProductImageryContent;
//# sourceMappingURL=ProductImageryContent.js.map